/**
 * @module DEV / Component - Slide
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, OnInit, Input, HostBinding, OnDestroy } from '@angular/core';
import {
  CarouselComponent,
  Direction,
} from '@support/shared/widgets/components/carousel/carousel.component';

@Component({
  selector: 'tmo-slide',
  template: `
    <div [class.active]="active" class="carousel-row info-container mixed">
      <ng-content></ng-content>
    </div>
  `,
})
export class SlideComponent implements OnInit, OnDestroy {
  @Input() public columns: number;
  @Input() public index: number;
  @Input() public direction: Direction;
  @HostBinding('class.active')
  @Input()
  public active: boolean;

  @HostBinding('class.item')
  @HostBinding('class.carousel-item')
  private addClass: boolean;

  constructor(private carousel: CarouselComponent) {
    this.addClass = true;
  }
  public ngOnInit(): void {
    this.carousel.addSlide(this);
  }
  /**
   * Unsubscribes for all subscriptions
   */
  public ngOnDestroy(): void {}
}
